import type { ColorValue } from "@sanity/color-input"
import { clsx } from "@/src/utils/clsx"

interface ColorGroupProps {
    color: ColorValue
    className?: string
}

export default function ColorGroup({ color, className }: ColorGroupProps) {
    return (
        <div
            style={{ backgroundColor: color.hex }}
            className={clsx("h-full w-full", className)}
        ></div>
    )
}
